
































































import { Component, Vue } from 'vue-property-decorator';
import { AppMain } from './components';
import { authService } from '../services/authService';

const changeViewSize = 700;

@Component({
  name: 'Layout',
  components: {
    AppMain,
  },
})
export default class extends Vue {
  private user: object = {};
  private userLoaded: boolean = false;
  isSidebarDefaultVisible = window.innerWidth >= changeViewSize;
  isSidebarHiding = !this.isSidebarDefaultVisible;
  get statusMessage() {
    return this.$root.$data.statusMessage;
  }
  signOut(): void {
    authService.signOut();
  }
  onToggleSidebar(){
    this.isSidebarHiding = !this.isSidebarHiding;
  }
  onRouterClick(){
    if (window.innerWidth <= changeViewSize){
      this.isSidebarHiding = true;
    }
  }
  onResize() {
    this.isSidebarDefaultVisible = window.innerWidth >= changeViewSize
  }
  mounted() {
    authService.getUser().then(user => {
      if(user){
        this.user = user;
        this.userLoaded = true;
      }
    })
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  }
  beforeDestroy() { 
      window.removeEventListener('resize', this.onResize); 
  };
}
